import { render, staticRenderFns } from "./UserSummary.vue?vue&type=template&id=0aa1efe0&scoped=true&"
import script from "./UserSummary.vue?vue&type=script&lang=js&"
export * from "./UserSummary.vue?vue&type=script&lang=js&"
import style0 from "./UserSummary.vue?vue&type=style&index=0&id=0aa1efe0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa1efe0",
  null
  
)

export default component.exports